export default {
  EXCLUDED: (state) => state.excluded,
};
